export default __webpack_public_path__ + "static/media/papel.5821a7dc.svg";